import { createContext } from 'react';
import { IAutomaticChargeContext } from '../interfaces/automatic-charge.interface';

export const AutomaticChargeContext = createContext({} as IAutomaticChargeContext);
